import styled from 'styled-components';
import { zIndex } from 'app/styles/variables';

export const CookieDashboardContentSt = styled.div`
  display: block;
  margin-top: 4rem;
  margin-bottom: 8rem;
`;

export const ContentSt = styled.div`
  color: ${({ theme }) => theme.colors.neutral800};

  h4 {
    margin: 0 auto;
  }

  p {
    margin: 2rem auto 1.5rem auto;
  }

  li {
    margin-bottom: 0.5rem;
    line-height: 2;
  }
`;

interface Props {
  isTopNavbarHidden: boolean;
}

export const CookieDashBoardContainerSt = styled.div<Props>`
  position: fixed;
  z-index: ${zIndex.navbar};
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  transform: ${({ isTopNavbarHidden }) =>
    isTopNavbarHidden ? 'translate3d(0, -64px, 0)' : 'translate3d(0, 0, 0)'};
  transition: transform 0.3s linear;
`;
